(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[108],{

/***/ 27733:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subjects",
      function () {
        return __webpack_require__(62383);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LandingPageContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./components/LandingPageHero.module.scss
var LandingPageHero_module = __webpack_require__(2231);
var LandingPageHero_module_default = /*#__PURE__*/__webpack_require__.n(LandingPageHero_module);
;// CONCATENATED MODULE: ./public/images/online-tutoring-bg-2.jpg
/* harmony default export */ var online_tutoring_bg_2 = ({"src":"/_next/static/media/online-tutoring-bg-2.400ce5c1.jpg","height":2880,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAUDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAgEAABAwMFAQAAAAAAAAAAAAACAAEDBQYSBBEhQUJR/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/EABYRAAMAAAAAAAAAAAAAAAAAAAAREv/aAAwDAQACEQMRAD8AlcV91iaomNK1jA0ZkxhGYM7D5yy72+cIiIyxUj//2Q==","blurWidth":5,"blurHeight":8});
// EXTERNAL MODULE: ./components/HeroSearch.js + 3 modules
var HeroSearch = __webpack_require__(56665);
;// CONCATENATED MODULE: ./components/LandingPageHero.js






function LandingPageHero(param) {
    let { page  } = param;
    const backgroundStyle = {
        backgroundImage: page.coverPhoto.url || online_tutoring_bg_2.src
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LandingPageHero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LandingPageHero_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: backgroundStyle.backgroundImage,
                className: (LandingPageHero_module_default()).staticBg,
                alt: "Cover photo",
                priority: true,
                fill: true,
                sizes: "100vw",
                style: {
                    objectFit: "cover",
                    objectPosition: "center"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                className: "".concat((LandingPageHero_module_default()).content, " pt-lg-4"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pb-2 pt-5 pb-lg-4 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-white pb-2",
                                children: page.header1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "h5 text-white",
                                children: page.subheader
                            })
                        ]
                    }),
                    page.showSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-2 mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((LandingPageHero_module_default()).searchContainer, " p-3 p-lg-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSearch/* default */.Z, {
                                subject: page.subject,
                                level: page.level,
                                location: page.marketingLocation,
                                modality: page.modality
                            })
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
;// CONCATENATED MODULE: ./components/LandingPageContainer.js





function LandingPageContainer(param) {
    let { page , children  } = param;
    const showBreadcrumbs = page.cachedDepth > 0;
    const sortedAncestors = page.ancestors.sort((a, b)=>a.cachedDepth - b.cachedDepth);
    const linkPath = (ancestor)=>{
        switch(ancestor.slug){
            case "subjects":
                return "/subjects";
            case "locations":
                return "/locations";
            default:
                return "/tutoring/".concat(ancestor.slug);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageHero, {
                page: page
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                className: "pt-lg-4",
                children: [
                    showBreadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        "aria-label": "breadcrumb",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                            className: "breadcrumb bg-transparent px-0",
                            itemScope: true,
                            itemType: "https://schema.org/BreadcrumbList",
                            children: [
                                sortedAncestors.map((ancestor)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "breadcrumb-item",
                                        itemProp: "itemListElement",
                                        itemScope: true,
                                        itemType: "https://schema.org/ListItem",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                            href: linkPath(ancestor),
                                            passHref: true,
                                            itemProp: "item",
                                            className: "text-decoration-none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    itemProp: "name",
                                                    children: ancestor.linkTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                    itemProp: "position",
                                                    content: ancestor.cachedDepth + 1
                                                })
                                            ]
                                        })
                                    }, ancestor.id)),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "breadcrumb-item active",
                                    "aria-current": "page",
                                    itemProp: "itemListElement",
                                    itemScope: true,
                                    itemType: "https://schema.org/ListItem",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            itemProp: "name",
                                            children: page.linkTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                            itemProp: "position",
                                            content: page.cachedDepth + 1
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    page.body1Text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: page.body1Text
                                }
                            })
                        })
                    }),
                    page.children && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "mb-4",
                        children: page.children.map((child)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/tutoring/".concat(child.slug),
                                passHref: true,
                                className: "badge bg-secondary fw-normal text-decoration-none p-2 me-2 mb-2",
                                children: child.linkTitle
                            }, child.id))
                    }),
                    children,
                    page.body2Text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: page.body2Text
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 1979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LandingPageHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function LandingPageHead(param) {
    let { page  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: page.pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: page.metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:title",
                content: page.pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: page.metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: page.pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: page.metaDescription
            })
        ]
    });
}


/***/ }),

/***/ 20768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LandingPageTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/LandingPageTile.module.scss
var LandingPageTile_module = __webpack_require__(37422);
var LandingPageTile_module_default = /*#__PURE__*/__webpack_require__.n(LandingPageTile_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/default-tile-cover.png
/* harmony default export */ var default_tile_cover = ({"src":"/_next/static/media/default-tile-cover.80dc6840.png","height":266,"width":400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAXVBMVEWsWGS/z8bNzM+UeY6VYVrQooaTkJHItpm4bnO2ZFmNa3LAg42mY3mwaG3MnpTBc3+8XG/RdXrSim+/rKzTm2CdhIeMgX+qtbCuwLvYqJOwppTQva3erlyZpY7PxJnpbCRhAAAACXBIWXMAAAsSAAALEgHS3X78AAAANUlEQVR4nGOQYGRkkpZjZ2dgk5WSlBFh5WNgExNnFRLk52ZgFmUS5hBg4GHgYmHh5OTlYAAAMmgB/B686NgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./components/LandingPageTile.js





const LandingPageTile = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { onClick , href , page  } = param;
    const imageUrl = page.thumbnail.url || default_tile_cover.src;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((LandingPageTile_module_default()).imageContainer, " mb-2"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: href,
                    onClick: onClick,
                    ref: ref,
                    className: (LandingPageTile_module_default()).imageLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: imageUrl,
                        className: (LandingPageTile_module_default()).image,
                        alt: page.header1,
                        fill: true,
                        sizes: "100vw"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: href,
                onClick: onClick,
                ref: ref,
                className: "d-block text-dark text-center text-decoration-none",
                children: page.linkTitle
            })
        ]
    });
});
LandingPageTile.displayName = "LandingPageTile";
/* harmony default export */ var components_LandingPageTile = (LandingPageTile);


/***/ }),

/***/ 62383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var _components_LandingPageTile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20768);
/* harmony import */ var _components_LandingPageContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86651);
/* harmony import */ var _components_LandingPageHead__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1979);






function Subjects(param) {
    let { page  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LandingPageHead__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                page: page
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LandingPageContainer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                page: page,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: page.children.map((child)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            xs: 12,
                            md: 3,
                            className: "mb-4",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/tutoring/".concat(child.slug),
                                passHref: true,
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LandingPageTile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    page: child
                                })
                            })
                        }, child.id))
                })
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Subjects);


/***/ }),

/***/ 2231:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPageHero_container__EvdJl","overlay":"LandingPageHero_overlay__c7zRq","image":"LandingPageHero_image__iHXo4","staticBg":"LandingPageHero_staticBg__hxVj7","content":"LandingPageHero_content__fi9qn","searchContainer":"LandingPageHero_searchContainer__Mvx9i","btn":"LandingPageHero_btn__1kSW3"};

/***/ }),

/***/ 37422:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"LandingPageTile_imageContainer__vIAv6","imageLink":"LandingPageTile_imageLink__qYp7c","image":"LandingPageTile_image__9cmfi"};

/***/ }),

/***/ 2086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  vertical: false,
  role: 'group'
};
const ButtonGroup = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  size,
  vertical,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...rest
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'btn-group');
  let baseClass = prefix;
  if (vertical) baseClass = `${prefix}-vertical`;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...rest,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, baseClass, size && `${prefix}-${size}`)
  });
});
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (ButtonGroup);

/***/ }),

/***/ 78182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 28984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35005);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








const noop = () => undefined;

const ToggleButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  name,
  className,
  checked,
  type,
  onChange,
  value,
  disabled,
  id,
  inputRef,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'btn-check');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input", {
      className: bsPrefix,
      name: name,
      type: type,
      value: value,
      ref: inputRef,
      autoComplete: "off",
      checked: !!checked,
      disabled: !!disabled,
      onChange: onChange || noop,
      id: id
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { ...props,
      ref: ref,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, disabled && 'disabled'),
      type: undefined,
      role: undefined,
      as: "label",
      htmlFor: id
    })]
  });
});
ToggleButton.displayName = 'ToggleButton';
/* harmony default export */ __webpack_exports__["Z"] = (ToggleButton);

/***/ }),

/***/ 17954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41143);
/* harmony import */ var invariant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(invariant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var uncontrollable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47150);
/* harmony import */ var _createChainedFunction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16833);
/* harmony import */ var _ElementChildren__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53439);
/* harmony import */ var _ButtonGroup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2086);
/* harmony import */ var _ToggleButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28984);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








const defaultProps = {
  type: 'radio',
  vertical: false
};
const ToggleButtonGroup = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const {
    children,
    type,
    name,
    value,
    onChange,
    ...controlledProps
  } = (0,uncontrollable__WEBPACK_IMPORTED_MODULE_2__/* .useUncontrolled */ .Ch)(props, {
    value: 'onChange'
  });

  const getValues = () => value == null ? [] : [].concat(value);

  const handleToggle = (inputVal, event) => {
    if (!onChange) {
      return;
    }

    const values = getValues();
    const isActive = values.indexOf(inputVal) !== -1;

    if (type === 'radio') {
      if (!isActive && onChange) onChange(inputVal, event);
      return;
    }

    if (isActive) {
      onChange(values.filter(n => n !== inputVal), event);
    } else {
      onChange([...values, inputVal], event);
    }
  };

  !(type !== 'radio' || !!name) ?  false ? 0 : invariant__WEBPACK_IMPORTED_MODULE_1___default()(false) : void 0;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ButtonGroup__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { ...controlledProps,
    ref: ref,
    children: (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI)(children, child => {
      const values = getValues();
      const {
        value: childVal,
        onChange: childOnChange
      } = child.props;

      const handler = e => handleToggle(childVal, e);

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, {
        type,
        name: child.name || name,
        checked: values.indexOf(childVal) !== -1,
        onChange: (0,_createChainedFunction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(childOnChange, handler)
      });
    })
  });
});
ToggleButtonGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(ToggleButtonGroup, {
  Button: _ToggleButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
}));

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [766,734,665,774,888,179], function() { return __webpack_exec__(27733); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);